export default __webpack_public_path__ + "static/media/img_2.eb52040e.png";